import React from 'react';
import './WearToRepair.css';

const cardContent = [
  {
    title: "Medical Wear",
    description: "Infection prevention apparel like gowns, shoe covers, aprons & more.",
    buttonText: "Explore →",
    buttonLink: "/products/disposable-medical-wear-collection",
    backgroundImage: require('../../../images/MedicalWearImage.webp'),
  },
  {
    title: "Surgical Consumables",
    description: "Pulse Lavage, Suction Tubes, Sagittal Blades & more.",
    buttonText: "Explore →",
    buttonLink: "/products/surgical-consumables",
    backgroundImage: require('../../../images/SurgicalCOnsumable.jpg'),
  },
  {
    title: "Orthopedic Implants & Instruments",
    description: "Reliable, high-precision orthopedic instruments.",
    buttonText: "Explore →",
    buttonLink: "/products/orthopedic-implants",
    backgroundImage: require('../../../images/OrthoImplantInstrument.webp'),
  },
  {
    title: "Orthopedic Consumables",
    description: "Clinical-grade support equipment for OR & patient care.",
    buttonText: "Explore →",
    buttonLink: "/products/orthopedic-consumables",
    backgroundImage: require('../../../images/OrthopedicConsumable.webp'),
  }
];

const Card = ({ title, description, buttonText, buttonLink, backgroundImage }) => (
  <div className="card-box" style={{ backgroundImage: `url(${backgroundImage})` }}>
    <div className="overlay"></div>
    <div className="content">
      <h2>{title}</h2>
      <p>{description}</p>
      <a href={buttonLink} target="_blank" rel="noopener noreferrer" className="btn-primary">
        {buttonText}
      </a>
    </div>
  </div>
);

const WearToRepair = () => (
  <div className='dare-to-leap'>
    <section className="wear-to-repair">
      <h2 className='homepage-section-title'>Product Categories</h2>
      <div className="cards-container">
        {cardContent.map((content, idx) => (
          <Card key={idx} {...content} />
        ))}
      </div>
    </section>
  </div>
);

export default WearToRepair;
